class EntrySimpleManager {
  /**
   * @param {HTMLElement} rootEl 
   */
  constructor(rootEl) {
    this.getHTMLElements(rootEl);
    this.initCarousel(rootEl);
  }


  diviserParN(nombre, div) {
    return Math.ceil(nombre / div);
}

  /**
   * @param {HTMLElement} rootEl 
   */
  getHTMLElements = (rootEl) => {
    this.rootEl = rootEl;
    this.entries = rootEl.querySelectorAll('.entries > .entry');
    this.carousel = jQuery(rootEl.querySelector('.owl-carousel'));
  }


  initCarousel = (rootEl) => {



    // var $parentcarousel =  rootEl;
    // console.log(rootEl)
    // var $conf_loop = rootEl.dataset.loop == "true" ? true : false;
    // var $conf_dots = rootEl.dataset.dots == "true" ? true : false;
    // var $conf_nav =  rootEl.dataset.nav == "true" ? true : false;





    let $nbritemsxl = rootEl.dataset.nbritemsxl > 0 ? rootEl.dataset.nbritemsxl : 4;
    let $nbritemslg = rootEl.dataset.nbritemslg > 0 ? rootEl.dataset.nbritemslg : 3;
    let $nbritemsmd = rootEl.dataset.nbritemsmd > 0 ? rootEl.dataset.nbritemsmd : 2;
    let $nbritemssm = rootEl.dataset.nbritemssm > 0 ? rootEl.dataset.nbritemssm : 1;

    let $conf_loop = rootEl.dataset.loop == "true" ? true : false;
    let $conf_dots = rootEl.dataset.dots == "true"? true : false;
    let $conf_nav = rootEl.dataset.nav == "true" ? true : false;
    let $conf_width = rootEl.dataset.width == "true" ? true : false;

    let $conf_margin = rootEl.dataset.margin > 0 ? parseInt(rootEl.dataset.margin) : 0;


    let $stagepadding = rootEl.dataset.stagepadding > 0 ? parseInt(rootEl.dataset.stagepadding) : 0;
    



    this.carousel.owlCarousel({

      loop: $conf_loop,
      autoplay: true,
      autoplaySpeed: 1500,
      autoplayTimeout: 10000,
      dots: $conf_dots,
      nav: $conf_nav,
      autoWidth:$conf_width,
      navText: ['<i class="fa-regular fa-arrow-left"></i>', '<i class="fa-regular fa-arrow-right"></i>'],
      margin: $conf_margin,
      autoplayHoverPause: true,
      center: false,
      startPosition: 1,
      onTranslated: this.updateActiveEntry,
      items: 1,
      smartSpeed:800,
      responsive: {
          0: {
            stagePadding: this.diviserParN($stagepadding, 4),
            items: $nbritemssm
          },
          992: {
            stagePadding: this.diviserParN($stagepadding, 2),
            items: $nbritemsmd
          },
          1200: {
            stagePadding: this.diviserParN($stagepadding, 1.5),
            items: $nbritemslg
          },
          1620: {
            stagePadding: this.diviserParN($stagepadding, 1),
            items: $nbritemsxl
          },
      }
    });
  }
}


jQuery(function() { 
  
  const entriesBlocks = document.querySelectorAll('.wp-block-plune-blocks-carousel');
  entriesBlocks.forEach(el => {
    new EntrySimpleManager(el);
  });
});




















// jQuery(document).ready(function ($) {
  

//   $(".wp-block-plune-blocks-carousel .owl-carousel").each( function() {

//     var $carousel = $(this);
//     var $parentcarousel =  $carousel.parent();
//     var $nbritemsxl = $parentcarousel.attr("data-nbritemsxl") > 0 ? $parentcarousel.attr("data-nbritemsxl") : 4;
//     var $nbritemslg = $parentcarousel.attr("data-nbritemslg") > 0 ? $parentcarousel.attr("data-nbritemslg") : 3;
//     var $nbritemsmd = $parentcarousel.attr("data-nbritemsmd") > 0 ? $parentcarousel.attr("data-nbritemsmd") : 2;
//     var $nbritemssm = $parentcarousel.attr("data-nbritemssm") > 0 ? $parentcarousel.attr("data-nbritemssm") : 2;

//     var $conf_loop = $parentcarousel.attr("data-loop") == "true" ? true : false;
//     var $conf_dots = $parentcarousel.attr("data-dots") == "true"? true : false;
//     var $conf_nav = $parentcarousel.attr("data-nav") == "true" ? true : false;

//     var $conf_margin = $parentcarousel.attr("data-margin") > 0 ? parseInt($parentcarousel.attr("data-margin")) : 0;

//     $carousel.owlCarousel({
//         loop: $conf_loop,
//         autoplay: true,
//         autoplaySpeed: 1000,
//         autoplayTimeout: 10000,
//         dots: $conf_dots,
//         nav: $conf_nav,
//         margin: $conf_margin,
//         animateOut: 'fadeOut',
//         animateIn: 'fadeIn',
//         autoplayHoverPause: true,
//         navText: ['<i class="fa-solid fa-chevron-left"></i>', '<i class="fa-solid fa-chevron-right"></i>'],
//         responsive: {
//           0: {
//             items: $nbritemssm
//           },
//           768: {
//             items: $nbritemsmd
//           },
//           1200: {
//             items: $nbritemslg
//           },
//           1400: {
//             items: $nbritemsxl
//           },
//         }
//     });


//     if($(this).hasClass("vertical")){
//       $carousel.data('owl.carousel').difference = function(first, second) {
//         return {
//           x: first.x - second.x + (first.y - second.y),
//           y: first.y - second.y
//         };
//       };
//     }





// });




// })



















































































